import {
  SET_HIDE_URL,
  SET_POSTS,
  SET_DESIGN_COLORS,
  SET_COLOR_PALETTES,
  SET_FONT_ADJUSTMENT,
  SET_IMAGE_POSITION,
  SET_IS_RANDOM_IMAGES,
  SET_IS_RANDOM_TEMPLATES,
  SET_TEMPLATE_SELECTIONS,
  REMOVE_FROM_TEMPLATE_SELECTIONS,
  SET_IS_GENERATING,
  SET_USE_ALL_COLORS,
  SET_SELECTED_COLOR_INDEX,
  SET_FONT_FAMILY,
  SET_FONT_COLOR,
  SET_USE_UPPER_CASE_FONT,
  SET_GET_IMAGES_IN_ARTICLE,
  SET_DESIGN_SETTINGS,
  UPLOAD_IMAGES,
  SET_IS_CONTAIN_IMAGES,
  SET_POST_OVERRIDES,
  SET_ETSY_STORE_NAME,
  UPDATE_SINGLE_POST,
  UPDATE_SINGLE_POST_LAYER,
  DELETE_SINGLE_POST_LAYER,
  UPDATE_POST_TEMPLATE_LAYER,
  SET_OVERRIDE_COLORS_AND_FONT,
  RESET_DESIGN_SETTINGS,
  USE_ONE_OF_EACH_TEMPLATE_CHANGE,
  DUPLICATE_POST,
  DELETE_POST,
  ADD_POSTS,
  SET_USE_ALL_DETECTED_IMAGES,
  SET_SELECTED_DETECTED_IMAGES,
  TOGGLE_SELECTED_DETECTED_IMAGES,
  SET_LOADING_DESIGN_SETTINGS,
  CREATE_POSTS_WITH_DESIGN_SETTINGS,
  SET_SELECTED_UPLOADED_IMAGES,
  TOGGLE_SELECTED_UPLOADED_IMAGES,
  SET_AI_LANGUAGE,
  SET_AI_KEYWORDS,
  SET_AI_TONE,
  SET_AI_IMAGE_CUSTOM_PROMPT,
  SET_SHOW_AI_IMAGE_CUSTOM_PROMPT,
  SET_INCLUDE_URL_IN_POST_TEXT,
  SET_AI_INCLUDE_HASHTAGS,
  SET_UPLOADED_FONTS,
  ADD_UPLOADED_FONT,
  DELETE_UPLOADED_FONT,
  SET_FIX_LOW_CONTRAST_TEXT,
  SET_USE_ONE_OF_EACH_IMAGE,
  SET_BATCH_CONTENT_LOADING,
  SET_UNAUTHORIZED_BATCH_ACCESS,
  SET_DESIGN_SETTINGS_PROFILES,
  RENAME_DESIGN_PROFILE,
  DELETE_DESIGN_PROFILE,
  SET_PICKED_TEMPLATE,
  SET_BYPASSS_RESIZE,
  SET_GENERATE_ALT_TEXT_WITH_AI,
  SET_GROUP_POSTS_BY,
  SET_SHOW_POST_TEXT,
} from "../types";

import config from "../../utils/config";
import { createRandomId } from "../../components/TemplateBuilder/Elements/StandardElementProperties";
import {
  setPostColorIndex,
  setTemplateType,
  selectPostImages,
} from "../../components/PostGenerator/postFormattingFunctions";

const initialState = {
  posts: config.initialPosts,
  designSettingsProfiles: {},
  designProfilesLoaded: false,
  isBatchContentLoading: false,
  unauthorizedBatchId: null,
  hideURL: false,
  designColors: [
    {
      color: {
        a: 1,
        r: 248,
        b: 168,
        g: 178,
      },
    },
    {
      color: {
        a: 1,
        r: 247,
        b: 115,
        g: 143,
      },
    },
    {
      color: {
        r: 191,
        g: 212,
        b: 126,
        a: 1,
      },
    },
    {
      color: {
        a: 1,
        r: 125,
        b: 199,
        g: 170,
      },
    },
    {
      color: {
        r: 249,
        g: 193,
        b: 120,
        a: 1,
      },
    },
  ],
  colorPalettes: [
    {
      colors: [
        {
          color: {
            a: 1,
            r: 218,
            g: 215,
            b: 205,
          },
        },
        {
          color: {
            a: 1,
            r: 163,
            g: 177,
            b: 138,
          },
        },
        {
          color: {
            a: 1,
            r: 88,
            g: 129,
            b: 87,
          },
        },
        {
          color: {
            a: 1,
            r: 58,
            g: 90,
            b: 64,
          },
        },
        {
          color: {
            a: 1,
            r: 52,
            g: 78,
            b: 65,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 248,
            b: 168,
            g: 178,
          },
        },
        {
          color: {
            a: 1,
            r: 247,
            b: 115,
            g: 143,
          },
        },
        {
          color: {
            r: 191,
            g: 212,
            b: 126,
            a: 1,
          },
        },
        {
          color: {
            a: 1,
            r: 125,
            b: 199,
            g: 170,
          },
        },
        {
          color: {
            r: 249,
            g: 193,
            b: 120,
            a: 1,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 205,
            b: 219,
            g: 180,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            b: 221,
            g: 200,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            b: 204,
            g: 175,
          },
        },
        {
          color: {
            a: 1,
            r: 189,
            b: 254,
            g: 224,
          },
        },
        {
          color: {
            a: 1,
            r: 162,
            b: 255,
            g: 210,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 204,
            b: 174,
            g: 213,
          },
        },
        {
          color: {
            a: 1,
            r: 233,
            b: 201,
            g: 237,
          },
        },
        {
          color: {
            a: 1,
            r: 254,
            b: 224,
            g: 250,
          },
        },
        {
          color: {
            a: 1,
            r: 250,
            b: 205,
            g: 237,
          },
        },
        {
          color: {
            a: 1,
            r: 212,
            b: 115,
            g: 163,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 38,
            g: 70,
            b: 83,
          },
        },
        {
          color: {
            a: 1,
            r: 42,
            g: 157,
            b: 143,
          },
        },
        {
          color: {
            a: 1,
            r: 233,
            g: 196,
            b: 106,
          },
        },
        {
          color: {
            a: 1,
            r: 244,
            g: 162,
            b: 97,
          },
        },
        {
          color: {
            a: 1,
            r: 231,
            g: 111,
            b: 81,
          },
        },
      ],
    },

    {
      colors: [
        {
          color: {
            a: 1,
            r: 205,
            g: 180,
            b: 219,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 200,
            b: 221,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 175,
            b: 204,
          },
        },
        {
          color: {
            a: 1,
            r: 189,
            g: 224,
            b: 254,
          },
        },
        {
          color: {
            a: 1,
            r: 162,
            g: 210,
            b: 255,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 96,
            b: 56,
            g: 108,
          },
        },
        {
          color: {
            a: 1,
            r: 40,
            b: 24,
            g: 54,
          },
        },
        {
          color: {
            a: 1,
            r: 254,
            b: 224,
            g: 250,
          },
        },
        {
          color: {
            a: 1,
            r: 221,
            b: 94,
            g: 161,
          },
        },
        {
          color: {
            a: 1,
            r: 188,
            b: 37,
            g: 108,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 231,
            g: 236,
            b: 239,
          },
        },
        {
          color: {
            a: 1,
            r: 39,
            g: 76,
            b: 119,
          },
        },
        {
          color: {
            a: 1,
            r: 96,
            g: 150,
            b: 186,
          },
        },
        {
          color: {
            a: 1,
            r: 163,
            g: 206,
            b: 241,
          },
        },
        {
          color: {
            a: 1,
            r: 139,
            g: 140,
            b: 137,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: { a: 1, r: 34, g: 87, b: 122 },
        },
        {
          color: { a: 1, r: 56, g: 163, b: 165 },
        },
        {
          color: { a: 1, r: 87, g: 204, b: 153 },
        },
        {
          color: { a: 1, r: 128, g: 237, b: 153 },
        },
        {
          color: { a: 1, r: 199, g: 249, b: 204 },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 0,
            b: 119,
            g: 109,
          },
        },
        {
          color: {
            a: 1,
            r: 131,
            b: 190,
            g: 197,
          },
        },
        {
          color: {
            a: 1,
            r: 237,
            b: 249,
            g: 246,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            b: 210,
            g: 221,
          },
        },
        {
          color: {
            a: 1,
            r: 226,
            b: 120,
            g: 149,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 120,
            g: 0,
            b: 0,
          },
        },
        {
          color: {
            a: 1,
            r: 193,
            g: 18,
            b: 31,
          },
        },
        {
          color: {
            a: 1,
            r: 253,
            g: 240,
            b: 213,
          },
        },
        {
          color: {
            a: 1,
            r: 0,
            g: 48,
            b: 73,
          },
        },
        {
          color: {
            a: 1,
            r: 102,
            g: 155,
            b: 188,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 255,
            g: 181,
            b: 167,
          },
        },
        {
          color: {
            a: 1,
            r: 252,
            g: 213,
            b: 206,
          },
        },
        {
          color: {
            a: 1,
            r: 248,
            g: 237,
            b: 235,
          },
        },
        {
          color: {
            a: 1,
            r: 249,
            g: 220,
            b: 196,
          },
        },
        {
          color: {
            a: 1,
            r: 254,
            g: 200,
            b: 154,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 255,
            g: 205,
            b: 178,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 180,
            b: 162,
          },
        },
        {
          color: {
            a: 1,
            r: 229,
            g: 152,
            b: 155,
          },
        },
        {
          color: {
            a: 1,
            r: 181,
            g: 131,
            b: 141,
          },
        },
        {
          color: {
            a: 1,
            r: 109,
            g: 104,
            b: 117,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 0,
            g: 0,
            b: 0,
          },
        },
        {
          color: {
            a: 1,
            r: 20,
            g: 33,
            b: 61,
          },
        },
        {
          color: {
            a: 1,
            r: 252,
            g: 163,
            b: 17,
          },
        },
        {
          color: {
            a: 1,
            r: 229,
            g: 229,
            b: 229,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 255,
            b: 255,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 237,
            g: 237,
            b: 233,
          },
        },
        {
          color: {
            a: 1,
            r: 214,
            g: 204,
            b: 194,
          },
        },
        {
          color: {
            a: 1,
            r: 245,
            g: 235,
            b: 224,
          },
        },
        {
          color: {
            a: 1,
            r: 227,
            g: 213,
            b: 202,
          },
        },
        {
          color: {
            a: 1,
            r: 213,
            g: 189,
            b: 175,
          },
        },
      ],
    },
    {
      colors: [
        {
          color: {
            a: 1,
            r: 216,
            g: 226,
            b: 220,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 229,
            b: 217,
          },
        },
        {
          color: {
            a: 1,
            r: 255,
            g: 202,
            b: 212,
          },
        },
        {
          color: {
            a: 1,
            r: 244,
            g: 172,
            b: 183,
          },
        },
        {
          color: {
            a: 1,
            r: 157,
            g: 129,
            b: 137,
          },
        },
      ],
    },
  ],
  fontColor: {
    color: {
      r: "255",
      g: "255",
      b: "255",
      a: "1",
    },
  },
  useAllColors: true,
  selectedColorIndex: 0,
  fontAdjustment: 0,
  isRandomImages: false,
  isContainImages: false,
  isRandomTemplates: false,
  useOneOfEachTemplate: true,
  templateSelections: [],
  pickedTemplate: null,
  isGenerating: false,
  fontFamily: "Carter One",
  fontUrl: null,
  useUpperCaseFont: true,
  uploadedImages: [],
  postOverrides: {
    title: "",
    URLText: "",
    description: "",
    url: "",
    brandName: "",
    logoImage: "",
  },
  etsyStoreName: "",
  overrideColorsAndFonts: false,
  imagePosition: "center center",
  useAllDetectedImages: true,
  useOneOfEachImage: false,
  selectedDetectedImages: [],
  selectedUploadedImages: [],
  isLoadingDesignSettings: false,
  aiLanguage: "English",
  aiKeywords: "", // comma separated
  aiTone: "Neutral",
  aiImageCustomPrompt: "",
  showAIImageCustomPrompt: false, // Toggle to show/hide custom AI image prompt field
  includeURLInPostText: false, // Controls whether to append website URL to post text when posting to social media
  aiIncludeHashtags: false,
  uploadedFonts: [],
  fixLowContrastText: false,
  name: "Default",
  bypassResize: false,
  generateAltTextWithAI: false,
  groupPostsBy: "none", // "none", "date", "platform"
  showPostText: true, // true to show description box above posts, false to hide
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPLOAD_IMAGES:
      return {
        ...state,
        uploadedImages: action.payload,
      };
    case SET_HIDE_URL:
      return {
        ...state,
        hideURL: action.payload,
      };
    case SET_POSTS: {
      // Create a lookup object for locked posts from the current state
      const lockedPostsById = {};
      (state.posts || []).forEach((post) => {
        if (post.isLocked) {
          lockedPostsById[post.id] = post;
        }
      });

      const newPostSet = action.payload.map((post) => {
        // If this post is locked (and exists in our lookup), merge with new incoming post if needed
        if (lockedPostsById[post.id]) {
          // Example merge: preserve locked flags but update template if necessary
          return {
            ...post,
            ...lockedPostsById[post.id],
            // Optionally merge toggled fields
          };
        } else {
          // Apply textDesignOverrides to the post
          if (state.overrideColorsAndFonts) {
            post.textDesignOverrides = {
              ...post.textDesignOverrides,
              fontFamily: state.fontFamily,
              fontUrl: state.fontUrl,
              color: state.fontColor.color,
              fontAdjustment: state.fontAdjustment,
              textTransform: state.useUpperCaseFont ? "uppercase" : "none",
            };
          } else {
            // remove the textDesignOverrides if they exist
            delete post.textDesignOverrides;
          }
          return post;
        }
      });

      return {
        ...state,
        posts: newPostSet,
      };
    }
    case CREATE_POSTS_WITH_DESIGN_SETTINGS: {
      // Skip design settings application if we're loading batch content or if batchId is present in URL
      const urlParams = new URLSearchParams(window.location.search);
      const hasBatchId = urlParams.get("batchId");
      const templatesFromURL = urlParams.get("templates");

      if (state.isBatchContentLoading || hasBatchId) {
        console.log(
          "🚫 Skipping design settings application - batch content present"
        );
        return state;
      }

      // If templates are set from URL, skip applying design settings to posts
      if (templatesFromURL) {
        console.log(
          "🚫 Skipping design settings post application - templates set from URL"
        );
        return state;
      }

      let postsWithColor = setPostColorIndex(
        [...state.posts],
        state.designColors,
        state.selectedColorIndex,
        state.useAllColors
      );

      let postsWithTemplateType = setTemplateType(
        postsWithColor,
        state.templateSelections,
        state.isRandomTemplates,
        [...action.payload.userTemplates, ...action.payload.standardTemplates],
        state.useOneOfEachTemplate
      );

      let postsWithSetImages = selectPostImages(
        postsWithTemplateType,
        state.isRandomImages,
        state.useAllDetectedImages,
        state.selectedDetectedImages,
        state.selectedUploadedImages,
        state.isRandomImages,
        state.postOverrides.logoImage,
        state.useOneOfEachImage
      );

      return {
        ...state,
        posts: postsWithSetImages,
      };
    }
    case DELETE_POST:
      let postsWithPostDeleted = state.posts.filter(
        (post) => post.id !== action.payload
      );
      return {
        ...state,
        posts: postsWithPostDeleted,
      };
    case ADD_POSTS:
      let postsWithPostAdded = state.posts.concat(action.payload);
      return {
        ...state,
        posts: postsWithPostAdded,
      };

    case SET_DESIGN_COLORS: {
      const newColorPalettes = state.colorPalettes.map((palette, index) =>
        index === 0 ? { ...palette, colors: action.payload } : palette
      );

      return {
        ...state,
        designColors: action.payload,
        colorPalettes: newColorPalettes,
      };
    }
    case SET_COLOR_PALETTES:
      return {
        ...state,
        colorPalettes: action.payload,
      };
    case SET_FONT_COLOR: {
      const postsWithFontColorOverride = state.posts.map((post) => {
        if (post.isLocked) return post;
        return {
          ...post,
          textDesignOverrides: {
            ...post.textDesignOverrides,
            color: action.payload.color,
          },
        };
      });

      return {
        ...state,
        fontColor: action.payload,
        posts: postsWithFontColorOverride,
      };
    }

    case SET_FONT_ADJUSTMENT: {
      const postsWithFontAdjustment = state.posts.map((post) => {
        if (post.isLocked) return post;
        return {
          ...post,
          textDesignOverrides: {
            ...post.textDesignOverrides,
            fontAdjustment: action.payload,
          },
        };
      });

      return {
        ...state,
        fontAdjustment: action.payload,
        posts: postsWithFontAdjustment,
      };
    }
    // case SET_IMAGE_POSITION:
    //   const postsWithImagePosition = state.posts.map((post) => {
    //     // Skip locked posts
    //     if (post.isLocked) return post;

    //     let newPost = post;

    //     newPost.imageDesignOverrides = {
    //       ...newPost.imageDesignOverrides,
    //       objectPosition: action.payload,
    //     };

    //     return newPost;
    //   });

    //   return {
    //     ...state,
    //     imagePosition: action.payload,
    //     posts: postsWithImagePosition,
    //   };
    case SET_IS_RANDOM_IMAGES:
      return {
        ...state,
        isRandomImages: action.payload,
      };
    case SET_IS_CONTAIN_IMAGES: {
      const postsWithContainImages = state.posts.map((post) => {
        if (post.isLocked) return post;

        if (action.payload) {
          return {
            ...post,
            imageDesignOverrides: {
              ...post.imageDesignOverrides,
              objectFit: "contain",
            },
          };
        } else {
          if (post.imageDesignOverrides) {
            const { objectFit, ...restOverrides } = post.imageDesignOverrides;
            return { ...post, imageDesignOverrides: restOverrides };
          }
          return post;
        }
      });

      return {
        ...state,
        isContainImages: action.payload,
        posts: postsWithContainImages,
      };
    }
    case SET_IS_RANDOM_TEMPLATES:
      return {
        ...state,
        isRandomTemplates: action.payload,
      };
    case SET_TEMPLATE_SELECTIONS:
      return {
        ...state,
        templateSelections: action.payload,
        isRandomTemplates: false,
      };
    case REMOVE_FROM_TEMPLATE_SELECTIONS: {
      let templateIdToRemove = action.payload;

      let newTemplateSelections = state.templateSelections.filter(
        (templateId) => templateId !== templateIdToRemove
      );

      return {
        ...state,
        templateSelections: newTemplateSelections,
      };
    }
    case SET_IS_GENERATING:
      return {
        ...state,
        isGenerating: action.payload,
      };
    case SET_USE_ALL_COLORS:
      return {
        ...state,
        useAllColors: action.payload,
      };
    case SET_SELECTED_COLOR_INDEX:
      return {
        ...state,
        selectedColorIndex: action.payload,
      };
    case SET_FONT_FAMILY: {
      let { fontFamily, fontUrl } = action.payload;

      let postsWithCorrectFont = state.posts;

      if (state.overrideColorsAndFonts) {
        postsWithCorrectFont = postsWithCorrectFont.map((post) => {
          if (post.isLocked) return post;
          return {
            ...post,
            textDesignOverrides: {
              ...post.textDesignOverrides,
              fontFamily,
              fontUrl,
            },
          };
        });
      }

      return {
        ...state,
        fontFamily,
        fontUrl,
        posts: postsWithCorrectFont,
      };
    }
    case SET_USE_UPPER_CASE_FONT: {
      const postsWithUpperCaseOverride = state.posts.map((post) => {
        if (post.isLocked) return post;
        return {
          ...post,
          textDesignOverrides: {
            ...post.textDesignOverrides,
            textTransform: action.payload ? "uppercase" : "none",
          },
        };
      });

      return {
        ...state,
        useUpperCaseFont: action.payload,
        posts: postsWithUpperCaseOverride,
      };
    }
    case SET_DESIGN_SETTINGS:
      return {
        ...state,
        posts: state.posts,
        ...action.payload,
        postOverrides: {
          ...state.postOverrides,
          ...action.payload.postOverrides,
        },
        uploadedImages: state.uploadedImages,
        isGenerating: state.isGenerating,
        designSettingsProfiles: state.designSettingsProfiles,
        designProfilesLoaded: true, // If we are setting the design settings, then we assume the profiles are loaded
      };
    case SET_POST_OVERRIDES:
      let newOverrides = Object.assign({}, state.postOverrides, action.payload);
      return {
        ...state,
        postOverrides: newOverrides,
      };
    case SET_ETSY_STORE_NAME:
      return {
        ...state,
        etsyStoreName: action.payload,
      };
    case UPDATE_SINGLE_POST:
      // Create a shallow copy of the posts array and update only the specific post
      // Avoid deep copying the entire posts array to prevent circular reference issues
      let newPosts2 = state.posts.map((post, index) => {
        if (index === action.payload.index) {
          return { ...post, ...action.payload.updateValues };
        } else {
          return post;
        }
      });

      return {
        ...state,
        posts: newPosts2,
      };
    case UPDATE_SINGLE_POST_LAYER:
      let newPostsWithUpdatedSingleLayer = state.posts.map((post, index) => {
        if (post.id === action.payload.postId) {
          let newLayers = post.template.layers.map((layer) => {
            if (layer.id === action.payload.layerId) {
              return { ...layer, ...action.payload.layerUpdates };
            }
            return layer;
          });

          return { ...post, template: { ...post.template, layers: newLayers } };
        }
        return post;
      });

      return {
        ...state,
        posts: newPostsWithUpdatedSingleLayer,
      };
    case DELETE_SINGLE_POST_LAYER:
      return {
        ...state,
        posts: state.posts.map((post, index) => {
          if (post.id === action.payload.postId) {
            let newTemplate = { ...post.template };

            // Create a safe copy of layers without circular references
            let newLayers = post.template.layers
              .filter((layer) => layer.id !== action.payload.layerId)
              .map((layer) => ({ ...layer }));

            newTemplate.layers = newLayers;
            return { ...post, template: newTemplate };
          }
          return post;
        }),
      };
    case UPDATE_POST_TEMPLATE_LAYER:
      let { postId, layerId, layerUpdates } = action.payload;

      return {
        ...state,
        posts: state.posts.map((post, index) => {
          if (post.id === postId) {
            let newTemplate = { ...post.template };
            let layers = [...post.template.layers];

            let newLayers = layers.map((layer) => {
              if (layer.id === layerId) {
                return { ...layer, ...layerUpdates };
              }
              return layer;
            });

            newTemplate.layers = newLayers;
            return { ...post, template: newTemplate };
          }
          return post;
        }),
      };
    case SET_OVERRIDE_COLORS_AND_FONT:
      let postsWithOverrides = state.posts.map((post, index) => {
        // Skip locked posts
        if (post.isLocked) return post;

        let newPost = { ...post };
        if (action.payload) {
          // If overrides are on
          newPost.textDesignOverrides = {
            color: state.fontColor.color,
            fontFamily: state.fontFamily,
            fontUrl: state.fontUrl,
            textTransform: state.useUpperCaseFont ? "uppercase" : "none",
            fontAdjustment: state.fontAdjustment,
          };
        } else {
          // If overrides are off
          if (typeof newPost.textDesignOverrides != "undefined") {
            delete newPost.textDesignOverrides;
          }
        }

        return newPost;
      });

      return {
        ...state,
        posts: [...postsWithOverrides],
        overrideColorsAndFonts: action.payload,
        fontAdjustment: action.payload ? state.fontAdjustment : 0, // Zero out font adjustment if overrides are off
      };
    case RESET_DESIGN_SETTINGS:
      return {
        ...initialState,
        posts: state.posts,
        uploadedImages: state.uploadedImages,
        isGenerating: state.isGenerating,
        designSettingsProfiles: state.designSettingsProfiles,
      };
    case USE_ONE_OF_EACH_TEMPLATE_CHANGE:
      return {
        ...state,
        useOneOfEachTemplate: action.payload,
      };
    case DUPLICATE_POST: {
      let postToDuplicate = state.posts[action.payload];
      let clonedTemplate = JSON.parse(JSON.stringify(postToDuplicate.template));
      let newPost = {
        ...postToDuplicate,
        id: createRandomId(),
        template: clonedTemplate,
        isPosting: false,
        isPosted: false,
        isDownloading: false,
        isDownloaded: false,
        isScheduling: false,
        isScheduled: false,
      };

      let newPosts = [
        ...state.posts.slice(0, action.payload + 1),
        newPost,
        ...state.posts.slice(action.payload + 1),
      ];

      return {
        ...state,
        posts: newPosts,
      };
    }
    case SET_USE_ALL_DETECTED_IMAGES: {
      return {
        ...state,
        useAllDetectedImages: action.payload,
      };
    }
    case SET_SELECTED_DETECTED_IMAGES: {
      return {
        ...state,
        selectedDetectedImages: action.payload,
      };
    }
    case TOGGLE_SELECTED_DETECTED_IMAGES: {
      let selectedDetectedImages;
      if (state.selectedDetectedImages.includes(action.payload)) {
        selectedDetectedImages = state.selectedDetectedImages.filter(
          (image) => image !== action.payload
        );
      } else {
        selectedDetectedImages = [...state.selectedDetectedImages, action.payload];
      }

      let postsWithImages = selectPostImages(
        [...state.posts],
        false,
        false,
        selectedDetectedImages,
        state.selectedUploadedImages,
        false,
        state.postOverrides.logoImage,
        state.useOneOfEachImage
      );

      return {
        ...state,
        posts: postsWithImages,
        selectedDetectedImages: selectedDetectedImages,
        isRandomImages: false,
        useAllDetectedImages: false,
      };
    }
    case SET_SELECTED_UPLOADED_IMAGES: {
      return {
        ...state,
        selectedUploadedImages: action.payload,
      };
    }
    case TOGGLE_SELECTED_UPLOADED_IMAGES: {
      let selectedUploadedImages;
      if (state.selectedUploadedImages.includes(action.payload)) {
        selectedUploadedImages = state.selectedUploadedImages.filter(
          (image) => image !== action.payload
        );
      } else {
        selectedUploadedImages = [...state.selectedUploadedImages, action.payload];
      }

      let postsWithImages = selectPostImages(
        [...state.posts],
        false,
        state.useAllDetectedImages,
        state.selectedDetectedImages,
        selectedUploadedImages,
        false,
        state.postOverrides.logoImage,
        state.useOneOfEachImage
      );

      return {
        ...state,
        posts: postsWithImages,
        selectedUploadedImages: selectedUploadedImages,
      };
    }
    case SET_LOADING_DESIGN_SETTINGS: {
      return {
        ...state,
        isLoadingDesignSettings: action.payload,
      };
    }
    case SET_AI_LANGUAGE: {
      return {
        ...state,
        aiLanguage: action.payload,
      };
    }
    case SET_AI_KEYWORDS: {
      return {
        ...state,
        aiKeywords: action.payload,
      };
    }
    case SET_AI_TONE: {
      return {
        ...state,
        aiTone: action.payload,
      };
    }
    case SET_AI_IMAGE_CUSTOM_PROMPT: {
      return {
        ...state,
        aiImageCustomPrompt: action.payload,
      };
    }
    case SET_SHOW_AI_IMAGE_CUSTOM_PROMPT: {
      return {
        ...state,
        showAIImageCustomPrompt: action.payload,
      };
    }
    case SET_INCLUDE_URL_IN_POST_TEXT: {
      return {
        ...state,
        includeURLInPostText: action.payload,
      };
    }
    case SET_AI_INCLUDE_HASHTAGS: {
      return {
        ...state,
        aiIncludeHashtags: action.payload,
      };
    }
    case SET_UPLOADED_FONTS: {
      return {
        ...state,
        uploadedFonts: action.payload,
      };
    }
    case ADD_UPLOADED_FONT: {
      return {
        ...state,
        uploadedFonts: [...state.uploadedFonts, action.payload],
      };
    }
    case DELETE_UPLOADED_FONT: {
      return {
        ...state,
        uploadedFonts: state.uploadedFonts.filter(
          (font) => font.id !== action.payload
        ),
      };
    }
    case SET_FIX_LOW_CONTRAST_TEXT: {
      return {
        ...state,
        fixLowContrastText: action.payload,
      };
    }
    case SET_USE_ONE_OF_EACH_IMAGE: {
      return {
        ...state,
        useOneOfEachImage: action.payload,
      };
    }
    case SET_BATCH_CONTENT_LOADING: {
      return {
        ...state,
        isBatchContentLoading: action.payload,
      };
    }
    case SET_UNAUTHORIZED_BATCH_ACCESS: {
      return {
        ...state,
        unauthorizedBatchId: action.payload,
      };
    }
    case SET_DESIGN_SETTINGS_PROFILES: {
      return {
        ...state,
        designSettingsProfiles: action.payload,
        designProfilesLoaded: true,
      };
    }
    case RENAME_DESIGN_PROFILE: {
      let { newProfileName, profileId } = action.payload;

      const profiles = {
        ...state.designSettingsProfiles,
        [profileId]: {
          ...state.designSettingsProfiles[profileId],
          name: newProfileName,
        },
      };

      return {
        ...state,
        name: state.id == profileId ? newProfileName : state.name,
        designSettingsProfiles: profiles,
      };
    }
    case DELETE_DESIGN_PROFILE: {
      const { [action.payload]: _removed, ...remainingProfiles } =
        state.designSettingsProfiles;

      return {
        ...state,
        designSettingsProfiles: remainingProfiles,
      };
    }
    case SET_PICKED_TEMPLATE: {
      return {
        ...state,
        pickedTemplate: action.payload,
      };
    }
    case SET_BYPASSS_RESIZE: {
      return {
        ...state,
        bypassResize: action.payload,
      };
    }
    case SET_GENERATE_ALT_TEXT_WITH_AI: {
      return {
        ...state,
        generateAltTextWithAI: action.payload,
      };
    }
    case SET_GROUP_POSTS_BY: {
      return {
        ...state,
        groupPostsBy: action.payload,
      };
    }
    case SET_SHOW_POST_TEXT: {
      return {
        ...state,
        showPostText: action.payload,
      };
    }
    default:
      return state;
  }
}
